import { isQuotingToolAvailable } from 'modules/common/permissions';

import { initDiscountDetailsPage } from './detailsPage/data/sagas';
import DiscountDetailsPage from './detailsPage/entry';
import { initDiscountsListPage } from './listPage/data/sagas';
import DiscountsListPage from './listPage/entry';

export default [
  {
    component: DiscountsListPage,
    exact: true,
    name: 'discountsListPage',
    path: '/processes/discounts',
    permissions: [isQuotingToolAvailable],
    saga: initDiscountsListPage,
  },
  {
    component: DiscountDetailsPage,
    exact: true,
    name: 'discountDetailsPage',
    path: '/processes/discounts/:discountId',
    permissions: [isQuotingToolAvailable],
    saga: initDiscountDetailsPage,
  },
];
